// Module
var code = "<div class=\"modal-terms\"> <div class=\"text-center\"> <h1>RÈGLEMENT</h1> </div> <h2>ARTICLE 1.</h2> <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p> </div>";
// Exports
module.exports = code;